import styled, { keyframes } from "styled-components";

// Enhanced Keyframe animations
export const slideInDown = keyframes`
  from { 
    transform: translateY(-80px) scale(0.95); 
    opacity: 0; 
  }
  to { 
    transform: translateY(0) scale(1); 
    opacity: 1; 
  }
`;

export const slideIn = keyframes`
  from { 
    transform: scale(0.65); 
    opacity: 0; 
  }
  to { 
    transform: scale(1); 
    opacity: 1; 
  }
`;

export const slideInUp = keyframes`
  from { 
    transform: translateY(60px) scale(0.95); 
    opacity: 0; 
  }
  to { 
    transform: translateY(0) scale(1); 
    opacity: 1; 
  }
`;

export const fadeIn = keyframes`
  from { 
    opacity: 0; 
  }
  to { 
    opacity: 1; 
  }
`;
export const fadeInUp = keyframes`
  from { 
    transform: translateY(40px) scale(0.98); 
    opacity: 0; 
  }
  to { 
    transform: translateY(0) scale(1); 
    opacity: 1; 
  }
`;

export const shimmer = keyframes`
  0% {
    transform: translateX(-100%) skewX(-15deg);
  }
  100% {
    transform: translateX(200%) skewX(-15deg);
  }
`;

export const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 6px 25px rgba(255, 107, 53, 0.6);
  }
`;

export const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

export const glow = keyframes`
  0%, 100% {
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.3));
  }
  50% {
    filter: drop-shadow(0 0 20px rgba(255, 107, 53, 0.6));
  }
`;

export const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0rem 2rem 2rem 2rem;

  width: 100%;
  position: relative;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        circle at 20% 80%,
        rgba(255, 107, 53, 0.05) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 80% 20%,
        rgba(255, 107, 53, 0.05) 0%,
        transparent 50%
      );
    pointer-events: none;
    opacity: 0.3;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const BackLink = styled.div`
  z-index: 100;
  display: flex;
  margin: 20px 0px;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
  color: #ff6b35;
  font-weight: bold;
  padding: 7.5px 15px;
  border-radius: 25px;
  background: rgba(26, 26, 26, 0.8);
  border: 1px solid rgba(255, 107, 53, 0.3);
  text-decoration: none;
  width: fit-content;
  transition: 0.3s;
  &:hover {
    background: #ff6b35;
    color: #fff;
    transform: translateX(-5px);
  }
`;

export const HeroSection = styled.div`
  background: ${({ $backgroundImage }) =>
    $backgroundImage
      ? `linear-gradient(
          135deg, 
          rgba(26, 26, 26, 0.8) 0%, 
          rgba(42, 42, 42, 0.9) 50%,
          rgba(26, 26, 26, 0.8) 100%
        ), 
        url(${$backgroundImage})`
      : "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  border-radius: 20px;
  padding: 3rem;
  margin-bottom: 3rem;
  outline: 2px solid rgba(255, 107, 53, 0.3);
  backdrop-filter: blur(15px);
  box-shadow: 0 20px 40px rgba(255, 107, 53, 0.25);
  position: relative;
  overflow: hidden;
  animation: ${slideInDown} 0.8s ease-out;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: ${({ $backgroundImage }) =>
    $backgroundImage ? "400px" : "auto"};
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #ff6b35, #ff8c42);
    border-radius: 20px 20px 0 0;
    z-index: 1;
  }

  &::after {
    content: "";
    position: absolute;
    top: -50%;
    right: -20%;
    width: 400px;
    height: 400px;
    background: radial-gradient(
      circle,
      rgba(255, 107, 53, 0.1) 0%,
      transparent 70%
    );
    pointer-events: none;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    background-attachment: scroll;
    min-height: ${({ $backgroundImage }) =>
      $backgroundImage ? "300px" : "auto"};
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  color: #ffffff;
`;

export const BandLogo = styled.div`
  font-size: 1rem;
  color: #ff6b35;
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 2px;
`;

export const BandTitle = styled.h1`
  color: #ffffff;
  font-size: 3rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.8) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 30px rgba(255, 255, 255, 0.3);

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const BandSubtitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    gap: 1rem;
    flex-direction: column;
    align-items: center;
  }
`;

export const GenreTag = styled.span`
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  color: #ffffff;
  padding: 5px 15px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const QuickActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
`;

export const ActionButton = styled.button`
  background: ${({ $primary }) =>
    $primary
      ? "linear-gradient(135deg, #ff6b35, #ff8c42)"
      : "linear-gradient(145deg, rgba(255, 107, 53, 0.15), rgba(255, 107, 53, 0.08))"};
  color: ${({ $primary }) => ($primary ? "#ffffff" : "#ff6b35")};
  border: 1px solid rgba(255, 107, 53, 0.3);
  padding: 12px 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.2);
  position: relative;
  overflow: hidden;
  white-space: nowrap;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${({ $primary }) =>
        $primary ? "rgba(255, 255, 255, 0.2)" : "rgba(255, 107, 53, 0.1)"},
      transparent
    );
    transition: all 0.6s;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    background: linear-gradient(135deg, #ff6b35, #ff8c42);
    color: #ffffff;
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4);
    border-color: #ff6b35;
  }

  svg {
    transition: all 0.3s;
  }

  &:hover svg {
    transform: scale(1.1);
  }

  &:disabled {
    background: #333;
    color: #666;
    border-color: #333;
    cursor: not-allowed;

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`;

// Empty State Components
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 107, 53, 0.2);
  }
`;

export const EmptyStateIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 107, 53, 0.1);
  border-radius: 50%;
  margin-bottom: 1rem;
  border: 1px solid rgba(255, 107, 53, 0.2);

  svg {
    color: #ff6b35;
    font-size: 1.5rem;
    opacity: 0.7;
  }
`;

export const EmptyStateText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
  margin: 0;
  font-style: italic;
  line-height: 1.4;
  max-width: 250px;
`;

export const TabNavigation = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  border-radius: 20px;
  padding: 0.8rem;
  overflow-x: auto;
  border: 2px solid rgba(255, 107, 53, 0.2);
  backdrop-filter: blur(15px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  animation: ${fadeInUp} 0.8s ease-out 0.2s both;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff6b35, #ff8c42);
    border-radius: 20px 20px 0 0;
  }

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(90deg, #ff6b35, #ff8c42);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    padding: 0.6rem;
    gap: 0.3rem;
  }
`;

export const TabButton = styled.button`
  background: ${({ $active }) =>
    $active ? "linear-gradient(135deg, #ff6b35, #ff8c42)" : "transparent"};
  color: ${({ $active }) => ($active ? "#ffffff" : "rgba(255, 255, 255, 0.7)")};
  border: ${({ $active }) =>
    $active
      ? "1px solid rgba(255, 107, 53, 0.5)"
      : "1px solid rgba(255, 255, 255, 0.1)"};
  padding: 0.8rem 1.2rem;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: ${({ $active }) => ($active ? "700" : "500")};
  font-size: 0.9rem;
  white-space: nowrap;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
  box-shadow: ${({ $active }) =>
    $active
      ? "0 4px 15px rgba(255, 107, 53, 0.3)"
      : "0 2px 8px rgba(0, 0, 0, 0.2)"};

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 107, 53, 0.2),
      transparent
    );
    transition: all 0.6s;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    background: ${({ $active }) =>
      $active
        ? "linear-gradient(135deg, #ff6b35, #ff8c42)"
        : "rgba(255, 107, 53, 0.15)"};
    color: #ffffff;
    transform: translateY(-2px) scale(1.02);
    border-color: rgba(255, 107, 53, 0.4);
    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4);
  }

  svg {
    transition: all 0.3s;
    filter: ${({ $active }) =>
      $active
        ? "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
        : "drop-shadow(0 1px 2px rgba(255, 107, 53, 0.3))"};
  }

  &:hover svg {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
    gap: 0.4rem;
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 2rem;
  align-items: start;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 320px;
    gap: 1.5rem;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const MainContent = styled.div`
  min-height: 600px;
`;

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  animation: ${slideInUp} 0.8s ease-out 0.6s both;
  position: sticky;
  top: 2rem;
  align-self: start;
`;

export const TabContent = styled.div`
  min-height: 400px;
`;

export const Section = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  border-radius: 20px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: -20%;
    right: -20%;
    width: 450px;
    height: 450px;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.05) 0%,
      transparent 70%
    );
    pointer-events: none;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  &:hover {
    border-color: rgba(255, 107, 53, 0.2);
  }
`;

export const SectionTitle = styled.h2`
  background: linear-gradient(135deg, #2c2c2c, #1a1a1a);
  color: #ff6b35;
  padding: 1.5rem 2rem;
  margin: 0;
  font-size: 1.3rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 1px solid #333;
`;

export const SectionContent = styled.div`
  padding: 2rem;
  color: #cccccc;
`;

export const BiographyText = styled.div`
  p {
    margin-bottom: 1.5rem;
    line-height: 1.7;
    font-size: 1.05rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
`;

export const InfoCard = styled.div`
  background: #2c2c2c;
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #333;
`;

export const InfoLabel = styled.div`
  color: #ff6b35;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 0.3rem;
`;

export const InfoValue = styled.div`
  color: #ffffff;
  font-size: 1rem;
`;

export const MemberCard = styled.div`
  background: #2c2c2c;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid #333;
  display: flex;
  gap: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
`;

export const MemberPhoto = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #ff6b35, #333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    margin: 0 auto;
  }
`;

export const MemberInfo = styled.div`
  flex: 1;
`;

export const MemberName = styled.h3`
  color: #ffffff;
  margin-bottom: 0.3rem;
  font-size: 1.2rem;
`;

export const MemberRole = styled.div`
  color: #ff6b35;
  font-weight: bold;
  margin-bottom: 0.8rem;
  font-size: 0.95rem;
`;

export const MemberBio = styled.p`
  color: #cccccc;
  line-height: 1.5;
  margin-bottom: 0.8rem;
  font-size: 0.95rem;
`;

export const DiscographyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const AlbumCard = styled.div`
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 50%,
    rgba(255, 255, 255, 0.08) 100%
  );
  border-radius: 20px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  backdrop-filter: blur(15px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
  display: flex;
  gap: 1.5rem;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 107, 53, 0.1),
      transparent
    );
    transition: all 0.6s;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 20px 50px rgba(255, 107, 53, 0.2);
    border-color: rgba(255, 107, 53, 0.3);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const AlbumCover = styled.div`
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
  box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4);
  animation: ${float} 3s ease-in-out infinite;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }
`;

export const AlbumInfo = styled.div`
  flex: 1;
  position: relative;
  z-index: 1;
`;

export const AlbumTitle = styled.h3`
  color: #ffffff;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
  background: linear-gradient(135deg, #ffffff, rgba(255, 255, 255, 0.8));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const AlbumYear = styled.div`
  color: #ff6b35;
  font-weight: bold;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  filter: drop-shadow(0 2px 4px rgba(255, 107, 53, 0.3));
`;

export const AlbumTracks = styled.div`
  margin-top: 1rem;
`;

export const TrackList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TrackItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  background: #1a1a1a;
  border-radius: 6px;

  &:hover {
    background: #333;
  }
`;

export const TrackNumber = styled.div`
  color: #ff6b35;
  font-weight: bold;
  min-width: 20px;
  font-size: 0.9rem;
`;

export const TrackName = styled.div`
  flex: 1;
  color: #cccccc;
  font-size: 0.9rem;
`;

export const TrackDuration = styled.div`
  color: #999;
  font-size: 0.85rem;
  font-family: monospace;
`;

export const EventCard = styled.div`
  background: #2c2c2c;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid #333;
  display: flex;
  align-items: center;
  gap: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
`;

export const EventDate = styled.div`
  background: #ff6b35;
  color: #ffffff;
  padding: 1rem;
  border-radius: 10px;
  text-align: center;
  min-width: 80px;

  .month {
    font-size: 0.8rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  .day {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.2rem;
  }
`;

export const EventInfo = styled.div`
  flex: 1;
`;

export const EventVenue = styled.h3`
  color: #ffffff;
  margin-bottom: 0.3rem;
  font-size: 1.1rem;
`;

export const EventCity = styled.div`
  color: #cccccc;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;

  svg {
    color: #ff6b35;
  }
`;

export const EventTickets = styled.div`
  flex-shrink: 0;
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
`;

export const GalleryItem = styled.div`
  aspect-ratio: 1;
  background: #2c2c2c;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #333;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: scale(1.05);
    border-color: #ff6b35;
    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.3);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.1);
  }

  .placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #666;
    text-align: center;
    padding: 1rem;

    span {
      margin-top: 0.5rem;
      font-size: 0.8rem;
    }
  }

  .main-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    background: linear-gradient(135deg, #ff6b35, #ff8c42);
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.7rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    z-index: 2;
    box-shadow: 0 2px 8px rgba(255, 107, 53, 0.4);
  }

  .image-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
    color: #ffffff;
    padding: 1rem 0.8rem 0.8rem;
    font-size: 0.8rem;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 2;
  }

  &:hover .image-info {
    opacity: 1;
  }
`;

export const StatsCard = styled.div`
  background: #2c2c2c;
  padding: 1rem;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #333;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StatNumber = styled.div`
  color: #ff6b35;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.3rem;
`;

export const StatLabel = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const SocialLinksExtended = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SocialLink = styled.a`
  background: #2c2c2c;
  color: #cccccc;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  border: 1px solid #333;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    transform: translateX(5px);
  }

  svg {
    font-size: 1.1rem;
  }

  span {
    font-size: 0.95rem;
    font-weight: 500;
  }
`;

export const AchievementsList = styled.div`
  margin-top: 2rem;

  h4 {
    color: #ff6b35;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }
`;

export const AchievementItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
  padding: 0.8rem;
  background: #2c2c2c;
  border-radius: 8px;
  border: 1px solid #333;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    color: #ff6b35;
    flex-shrink: 0;
  }
`;

// Image Modal Components
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(10px);
  animation: ${fadeIn} 0.3s ease-out;
  cursor: pointer;
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${slideIn} 0.3s ease-in-out;
`;

export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 107, 53, 0.3);
`;

export const ModalInfo = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  color: #ffffff;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  margin-top: 1rem;
  border: 1px solid rgba(255, 107, 53, 0.3);
  backdrop-filter: blur(15px);
  text-align: center;

  h3 {
    color: #ff6b35;
    margin: 0 0 0.5rem 0;
    font-size: 1.1rem;
  }

  p {
    color: #cccccc;
    margin: 0;
    font-size: 0.9rem;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  border: 2px solid rgba(255, 107, 53, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: #ff6b35;
    border-color: #ff6b35;
    transform: scale(1.1);
  }

  svg {
    font-size: 1.2rem;
  }
`;
